import { IEntityInfo, NSARouterMakerResult } from "namirasoft-account-react";
import { CategoryInputRow, CategoryRow, CategoryScopeInputRow, CategoryScopeRow, FieldInputRow, FieldRow, SlotInputRow, SlotRow } from "namirasoft-field";
import { FieldRoutes } from "./FieldRoutes";
import { NSBaseServer } from "namirasoft-site";
import { ProductUUID } from "namirasoft-api-product";
import { BaseColumnFormatter, BooleanFormatter, DateTimeFormatter, EnumFormatter, IDFormatter, JsonFormatter, StringFormatter, StringFormatterSizeType } from "namirasoft-site-react";
import { NSBaseMetaTable } from "namirasoft-site";
import { NamirasoftMap } from "namirasoft-site-map";
import { IStorageLocal, NamingConvention } from "namirasoft-core";
import { FieldProps } from "./FieldProps";

export class FieldEntities
{
	static getFieldEntities(product_id: string)
	{
		let tables: { [name: string]: NSBaseMetaTable<NSBaseServer, {}>; } = {};
		if (product_id)
		{
			try
			{
				let namirasoft = new NamirasoftMap();

				let meta = namirasoft.getByProductID(product_id);
				for (let table of Object.keys(meta.tables))
					if (!meta.tables[table].isCFTTable() && meta.tables[table].hasFieldTables())
						tables[table] = meta.tables[table];
			} catch (error)
			{
			}
		}
		return tables;
	}
	static category(props: NSARouterMakerResult & FieldProps): IEntityInfo<CategoryRow, CategoryInputRow>
	{
		let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

		return {
			product_id: ProductUUID.NAMIRASOFT_FIELD,
			name: "category",
			tables: [{ table: namirasoft.field.tables.category, required: true }],
			client: {
				getColumns()
				{
					return [
						BaseColumnFormatter.getColumn(namirasoft.field.tables.category.columns.id, new IDFormatter(namirasoft, null)),
						BaseColumnFormatter.getColumn(namirasoft.field.tables.category.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.field.tables.category.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.field.tables.category.columns.category_scope_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.field.tables.category.columns.name, new StringFormatter(StringFormatterSizeType.Sentence)),
						BaseColumnFormatter.getColumn(namirasoft.field.tables.category.columns.description, new StringFormatter(StringFormatterSizeType.Description)),
						BaseColumnFormatter.getColumn(namirasoft.field.tables.category.columns.created_at, new DateTimeFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.field.tables.category.columns.updated_at, new DateTimeFormatter()),
					]
				},
				getListURL: () => FieldRoutes.CategoryList,
				getNewURL: () => FieldRoutes.CategoryNew,
				getCopyURL: (id: string) => FieldRoutes.CategoryCopy(id),
				getEditURL: (id: string) => FieldRoutes.CategoryEdit(id),
				getViewURL: (id: string) => FieldRoutes.CategoryView(id),
			},
			server: {
				value_list: props.servers.field.value.List,
				get: props.servers.field.category.Get,
				list: props.servers.field.category.List,
				create: props.servers.field.category.Create,
				update: props.servers.field.category.Update,
				delete: props.servers.field.category.Delete
			}
		};
	}
	static category_scope(props: NSARouterMakerResult & FieldProps): IEntityInfo<CategoryScopeRow, CategoryScopeInputRow>
	{
		let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

		return {
			product_id: ProductUUID.NAMIRASOFT_FIELD,
			name: "category_scope",
			tables: [{ table: namirasoft.field.tables.category_scope, required: true }],
			client: {
				getColumns()
				{
					return [
						BaseColumnFormatter.getColumn(namirasoft.field.tables.category_scope.columns.id, new IDFormatter(namirasoft, null)),
						BaseColumnFormatter.getColumn(namirasoft.field.tables.category_scope.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.field.tables.category_scope.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.field.tables.category_scope.columns.name, new StringFormatter(StringFormatterSizeType.Sentence)),
						BaseColumnFormatter.getColumn(namirasoft.field.tables.category_scope.columns.description, new StringFormatter(StringFormatterSizeType.Description)),
						BaseColumnFormatter.getColumn(namirasoft.field.tables.category_scope.columns.created_at, new DateTimeFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.field.tables.category_scope.columns.updated_at, new DateTimeFormatter()),
					]
				},
				getListURL: () => FieldRoutes.CategoryScopeList,
				getNewURL: () => FieldRoutes.CategoryScopeNew,
				getCopyURL: (id: string) => FieldRoutes.CategoryScopeCopy(id),
				getEditURL: (id: string) => FieldRoutes.CategoryScopeEdit(id),
				getViewURL: (id: string) => FieldRoutes.CategoryScopeView(id),
			},
			server: {
				value_list: props.servers.field.value.List,
				get: props.servers.field.category_scope.Get,
				list: props.servers.field.category_scope.List,
				create: props.servers.field.category_scope.Create,
				update: props.servers.field.category_scope.Update,
				delete: props.servers.field.category_scope.Delete
			}
		};
	}
	static field(props: NSARouterMakerResult & FieldProps): IEntityInfo<FieldRow, FieldInputRow>
	{
		let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

		return {
			product_id: ProductUUID.NAMIRASOFT_FIELD,
			name: "field",
			tables: [{ table: namirasoft.field.tables.field, required: true }],
			client: {
				getColumns()
				{
					return [
						BaseColumnFormatter.getColumn(namirasoft.field.tables.field.columns.id, new IDFormatter(namirasoft, null)),
						BaseColumnFormatter.getColumn(namirasoft.field.tables.field.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.field.tables.field.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.field.tables.field.columns.name, new StringFormatter(StringFormatterSizeType.TwoWords)),
						BaseColumnFormatter.getColumn(namirasoft.field.tables.field.columns.type, new JsonFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.field.tables.field.columns.description, new StringFormatter(StringFormatterSizeType.Description)),
						BaseColumnFormatter.getColumn(namirasoft.field.tables.field.columns.created_at, new DateTimeFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.field.tables.field.columns.updated_at, new DateTimeFormatter()),
					]
				},
				getListURL: () => FieldRoutes.FieldList,
				getNewURL: () => FieldRoutes.FieldNew,
				getCopyURL: (id: string) => FieldRoutes.FieldCopy(id),
				getEditURL: (id: string) => FieldRoutes.FieldEdit(id),
				getViewURL: (id: string) => FieldRoutes.FieldView(id),
			},
			server: {
				value_list: props.servers.field.value.List,
				get: props.servers.field.field.Get,
				list: props.servers.field.field.List,
				create: props.servers.field.field.Create,
				update: props.servers.field.field.Update,
				delete: props.servers.field.field.Delete,
			}
		};
	}
	static slot(props: NSARouterMakerResult & FieldProps): IEntityInfo<SlotRow, SlotInputRow>
	{
		let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

		return {
			product_id: ProductUUID.NAMIRASOFT_FIELD,
			name: "slot",
			tables: [{ table: namirasoft.field.tables.slot, required: true }],
			client: {
				getColumns()
				{
					return [
						BaseColumnFormatter.getColumn(namirasoft.field.tables.slot.columns.id, new IDFormatter(namirasoft, null)),
						BaseColumnFormatter.getColumn(namirasoft.field.tables.slot.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.field.tables.slot.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.field.tables.slot.columns.product_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.field.tables.slot.columns.entity, new StringFormatter(StringFormatterSizeType.TwoWords, NamingConvention.Pascal_Case_Space)),
						BaseColumnFormatter.getColumn(namirasoft.field.tables.slot.columns.tab, new StringFormatter(StringFormatterSizeType.TwoWords)),
						BaseColumnFormatter.getColumn(namirasoft.field.tables.slot.columns.name, new StringFormatter(StringFormatterSizeType.TwoWords)),
						BaseColumnFormatter.getColumn(namirasoft.field.tables.slot.columns.entity_type, new EnumFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.field.tables.slot.columns.entity_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.field.tables.slot.columns.position_side, new EnumFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.field.tables.slot.columns.position_target, new StringFormatter(StringFormatterSizeType.TwoWords)),
						BaseColumnFormatter.getColumn(namirasoft.field.tables.slot.columns.size, new EnumFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.field.tables.slot.columns.required, new BooleanFormatter("Yes", "No")),
						BaseColumnFormatter.getColumn(namirasoft.field.tables.slot.columns.multiple, new BooleanFormatter("Yes", "No")),
						BaseColumnFormatter.getColumn(namirasoft.field.tables.slot.columns.description, new StringFormatter(StringFormatterSizeType.Description)),
						BaseColumnFormatter.getColumn(namirasoft.field.tables.slot.columns.created_at, new DateTimeFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.field.tables.slot.columns.updated_at, new DateTimeFormatter()),
					]
				},
				getListURL: () => FieldRoutes.SlotList,
				getNewURL: () => FieldRoutes.SlotNew,
				getCopyURL: (id: string) => FieldRoutes.SlotCopy(id),
				getEditURL: (id: string) => FieldRoutes.SlotEdit(id),
				getViewURL: (id: string) => FieldRoutes.SlotView(id),
			},
			server: {
				value_list: props.servers.field.value.List,
				get: props.servers.field.slot.Get,
				list: props.servers.field.slot.List,
				create: props.servers.field.slot.Create,
				update: props.servers.field.slot.Update,
				delete: props.servers.field.slot.Delete,
			}
		};
	}
}